module.exports = __webpack_public_path__ + "img/logo_2@2x.f686ee7f.png";